import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { INITIAL_LOADING } from '~/actions';
import useLoading from '~/hooks/useLoading';
import { useUserSelector } from '~/hooks/useUserSelector';
import { routes } from '~/routes';

// If the visitor isn't authenticated, send them back to /signup.
// Otherwise let the step page render normally.
export const useRequireSignUpStep = () => {
  const navigate = useNavigate();
  const user = useUserSelector();
  const { isLoading: isInitialLoading } = useLoading([INITIAL_LOADING]);

  useEffect(() => {
    if (isInitialLoading) return;
    if (!user) {
      navigate(routes.signUpRedesign.signUp, { replace: true });
    }
  }, [user, navigate, isInitialLoading]);
};
